"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const toolkit_1 = require("@reduxjs/toolkit");
const react_i18next_1 = require("react-i18next");
const primaryButton_1 = __importDefault(require("../../components/primaryButton/primaryButton"));
const utils_1 = require("../../utils/utils");
const choices_1 = require("../../utils/choices");
const loanApplicationSlice_1 = require("./loanApplicationSlice");
const screenConstants_1 = require("../../constants/screenConstants");
const store_1 = require("../../store");
const homeSlice_1 = require("../home/homeSlice");
const useAppNavigation_1 = __importDefault(require("../../hooks/useAppNavigation"));
const text_1 = __importStar(require("../../components/text/text"));
const input_1 = __importStar(require("../../components/input/input"));
const navContainer_1 = __importDefault(require("../../components/navContainer/navContainer"));
const analytics_1 = require("../../utils/analytics/analytics");
const LoanApplicationGuarantor = () => {
    const dispatch = (0, store_1.useAppDispatch)();
    const { t } = (0, react_i18next_1.useTranslation)();
    const { logEventWithExtraProperties } = (0, analytics_1.useAnalytics)();
    const navigation = (0, useAppNavigation_1.default)();
    const { loanApplicationId, messages } = (0, store_1.useAppSelector)((state) => ({
        loanApplicationId: state.home.ongoing_application
            ? state.home.ongoing_application.id
            : state.loanApplication.loan_application_id,
        messages: state.home.appMessages,
    }));
    const [title, setTitle] = (0, react_1.useState)('');
    const [firstName, setFirstName] = (0, react_1.useState)('');
    const [lastName, setLastName] = (0, react_1.useState)('');
    const [gender, setGender] = (0, react_1.useState)('');
    const [dateOfBirth, setDateOfBirth] = (0, react_1.useState)('');
    // const [nin, setNin] = useState('');
    const [bvnState, setBvn] = (0, react_1.useState)('');
    // const [choiceState, setChoice] = useState(0);
    const [email, setEmail] = (0, react_1.useState)('');
    const [phoneNumber, setPhoneNumber] = (0, react_1.useState)('');
    const [errors, setErrors] = (0, react_1.useState)();
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const submitForm = async () => {
        setIsLoading(true);
        const payload = {
            title,
            first_name: firstName.toString(),
            last_name: lastName.toString(),
            gender,
            date_of_birth: (0, utils_1.databaseDateFormat)(dateOfBirth.toString()),
            // nin,
            bvn: bvnState.toString(),
            email: email.toString(),
            phone_number: phoneNumber.toString(),
            loanApplicationId,
        };
        const result = await dispatch((0, loanApplicationSlice_1.sendGuarantor)(payload));
        logEventWithExtraProperties('api_call', {
            name: 'submit_guarantor_information',
            status: 'submitted',
            location: 'screen_LoanApplicationGuarantor',
        });
        if ((0, toolkit_1.isFulfilled)(result)) {
            logEventWithExtraProperties('api_call', {
                name: 'submit_guarantor_information',
                status: 'success',
                location: 'screen_LoanApplicationGuarantor',
            });
            setErrors(undefined);
            setIsLoading(false);
            if (messages) {
                // if has messasges it means is in the flow of the application
                dispatch((0, homeSlice_1.showMessage)());
            }
            else {
                navigation.navigate(screenConstants_1.HOME_SCREEN);
            }
        }
        else {
            logEventWithExtraProperties('api_call', {
                name: 'submit_guarantor_information',
                status: 'fail',
                location: 'screen_LoanApplicationGuarantor',
            });
            setErrors(result.payload);
            setIsLoading(false);
        }
    };
    return (react_1.default.createElement(navContainer_1.default, { errors: errors, isLoading: isLoading, childrenTitle: "Guarantor", footer: react_1.default.createElement(primaryButton_1.default, { disabled: !loanApplicationId, title: "Continue", onPress: submitForm, eventName: "guarantor_submit" }) },
        react_1.default.createElement(text_1.default, { titleType: text_1.TEXT_TYPE_SUBTITLE }, t('loanApplicationGuarantor.intro_text')),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_PICKER, choices: choices_1.titleChoices, label: "Title", setValue: setTitle, value: title, error: (0, utils_1.getError)('title', errors), optional: true }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_TEXT, label: "First name", placeholder: "First name", setValue: setFirstName, error: (0, utils_1.getError)('first_name', errors), value: firstName }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_TEXT, label: "Last name", placeholder: "Last name", setValue: setLastName, error: (0, utils_1.getError)('last_name', errors), value: lastName }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_PICKER, label: "Gender", choices: choices_1.genderChoices, setValue: setGender, value: gender, error: (0, utils_1.getError)('gender', errors) }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_DATE, label: "Date of birth", setValue: setDateOfBirth, value: dateOfBirth, error: (0, utils_1.getError)('date_of_birth', errors) }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_NUMBER, isBVN: true, label: "BVN", placeholder: "BVN", setValue: setBvn, value: bvnState, error: (0, utils_1.getError)('bvn', errors) }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_EMAIL, label: "Email", placeholder: "Email", setValue: setEmail, error: (0, utils_1.getError)('email', errors), value: email }),
        react_1.default.createElement(input_1.default, { type: input_1.INPUT_TYPE_PHONE, label: "Phone number", setValue: setPhoneNumber, error: (0, utils_1.getError)('phone_number', errors), value: phoneNumber })));
};
exports.default = LoanApplicationGuarantor;
